const BeneficiaryPhoneNumberDirective = angular
    .module("BeneficiaryPhoneNumberDirective", [])
    .directive("pwPhoneNumber", phoneNumber);

/**
 * @see http://stackoverflow.com/a/19228302/4454238
 */
function phoneNumber() {
    return {
        require: "ngModel",
        restrict: "A",
        priority: 1000,
        link: function (scope, element, attr, ctrl) {
            var pattern = /^\d{10}$/;

            var newValue = null;

            ctrl.$validators.validDigits = function (modelValue, viewValue) {
                if (ctrl.$isEmpty(modelValue)) {
                    // consider empty models to be valid
                    return true;
                }
                if (pattern.test(modelValue)) {
                    // it is valid
                    return true;
                }
                // it is invalid
                return false;
            };
        }
    };
}

export default BeneficiaryPhoneNumberDirective;
